/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import PeriodoMetricStrip from './PeriodoMetricStrip';
import RitmoTrendChart from './RitmoTrendChart';
import { UNIDADE_LABELS } from './constants';

const ProjecaoCicloPanel = ({ resumo, unidade, loading }) => {
  if (loading) {
    return (
      <Paper variant="outlined" sx={{ p: 2, height: '100%', borderRadius: 2 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Projeção do ciclo</Typography>
        <Typography variant="body2" color="text.secondary">Carregando…</Typography>
      </Paper>
    );
  }

  const unitLabel = UNIDADE_LABELS[unidade] ?? 'serviços';
  const projecao = resumo.projecaoFimPeriodo;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        height: '100%',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        Projeção do ciclo
      </Typography>
      {projecao != null ? (
        <Stack spacing={1} sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.2 }}>
            {projecao}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {unitLabel} estimados no fim do ciclo no ritmo atual
          </Typography>
          {resumo.metaPeriodo != null && (
            <Typography variant="caption" color="text.secondary">
              Meta do ciclo: {resumo.metaPeriodo} {unitLabel}
            </Typography>
          )}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Projeção indisponível para este período.
        </Typography>
      )}
    </Paper>
  );
};

ProjecaoCicloPanel.propTypes = {
  resumo: PropTypes.object.isRequired,
  unidade: PropTypes.string,
  loading: PropTypes.bool,
};

ProjecaoCicloPanel.defaultProps = {
  unidade: 'servicos',
  loading: false,
};

const RitmoHero = ({
  resumo,
  lente,
  loading,
  onKpiClick,
  alertSlot,
  sidePanel,
}) => {
  const unidade = lente?.unidade ?? resumo.unidade ?? 'servicos';
  const metaDiaria = resumo.metaDiaria ?? lente?.metaDiaria;
  const ultimos7Dias = resumo.ultimos7Dias?.length
    ? resumo.ultimos7Dias
    : resumo.meuPeriodo?.ultimos7Dias ?? [];
  const rightPanel = sidePanel ?? (
    <ProjecaoCicloPanel
      resumo={resumo}
      unidade={unidade}
      loading={loading}
    />
  );

  return (
    <Stack spacing={2}>
      <PeriodoMetricStrip
        resumo={resumo}
        lente={lente}
        loading={loading}
        onKpiClick={onKpiClick}
      />

      {alertSlot}

      <Grid container spacing={2} alignItems="stretch">
        <Grid size={{ xs: 12, md: 8 }}>
          <Box
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 2,
              p: 1.5,
              height: '100%',
            }}
          >
            <Typography variant="subtitle2" display="block" sx={{ mb: 0.5 }}>
              Digitação Últimos 7 dias
            </Typography>
            {!loading ? (
              <RitmoTrendChart
                ultimos7Dias={ultimos7Dias}
                metaDiaria={metaDiaria}
                unidade={unidade}
              />
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
                Carregando ritmo…
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          {rightPanel}
        </Grid>
      </Grid>
    </Stack>
  );
};

RitmoHero.propTypes = {
  resumo: PropTypes.object.isRequired,
  lente: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    unidade: PropTypes.string,
    metaDiaria: PropTypes.number,
  }),
  loading: PropTypes.bool,
  onKpiClick: PropTypes.func.isRequired,
  alertSlot: PropTypes.node,
  sidePanel: PropTypes.node,
};

RitmoHero.defaultProps = {
  lente: null,
  loading: false,
  alertSlot: null,
  sidePanel: null,
};

export default RitmoHero;
